import type { ConditionalDispatchItem } from 'client/js/main/routers/DispatchConfiguration/ConditionalDispatchItem';

export class InitialApiDispatcher {
  constructor(
    private dispatches: ConditionalDispatchItem[][],
    private store,
    private settings
  ) {}

  public dispatch() {
    this.dispatches.forEach((dispatchGroup) => {
      dispatchGroup.forEach((item) => {
        const { flipper, view } = item;

        if (this.shouldInvokeDispatchForFlipperAndView(flipper, view)) {
          this.invokeDispatch(item);
        }

        return;
      });
    });
  }

  private invokeDispatch(item: ConditionalDispatchItem) {
    if (item.toDispatch) {
      this.store.dispatch(item.toDispatch());
    } else if (item.toDispatchWithStore) {
      item.toDispatchWithStore(this.store, this.settings);
    }
  }

  private shouldInvokeDispatchForFlipperAndView(flipper: string | undefined, view: string | undefined) {
    if (!flipper) {
      if (this.shouldInvokeDispatchForView(view)) {
        return true;
      }
    } else if (this.settings.flipper[flipper]) {
      if (this.shouldInvokeDispatchForView(view)) {
        return true;
      }
    }
    return false;
  }

  private shouldInvokeDispatchForView(view: string | undefined) {
    return !view || view === this.settings.view.current_view;
  }
}
